declare var STATIC_BASE_URL:string;
declare var BASE_URL:string;

import {h, Component, createRef} from 'preact';
import { Link } from 'preact-router/match';
import Illustration from "./illustration";

import '../styles/frames.scss';
import '../styles/productsDemo.scss';

export default class Productsdemo extends Component<any, any> {
  case1 = createRef();
  case2 = createRef();
  case3 = createRef();
  // case4 = createRef();
  video1 = createRef();
  video2 = createRef();
  video3 = createRef();
  // video4 = createRef();
  
  constructor() {
    super();
  }
  
  public componentDidMount(): void {
    this.scrollCheck();
    document.addEventListener('scroll', this.scrollCheck.bind(this), false);
  }
  
  public componentWillUnmount(): void {
    document.removeEventListener('scroll', this.scrollCheck, false);
  }
  
  private scrollCheck(): void {
    if (
      this.case1 &&
      this.case1.current.getBoundingClientRect().bottom > window.innerHeight / 2 &&
      this.video1.current.classList.contains('hide')
    ) {
      this.video1.current.classList.remove('hide');
      this.video2.current.classList.add('hide');
      this.video3.current.classList.add('hide');
      this.case1.current.classList.remove('inactive');
      this.case2.current.classList.add('inactive');
      this.case3.current.classList.add('inactive');
    }
    if (
      this.case2 &&
      this.case2.current.getBoundingClientRect().top < window.innerHeight / 2 &&
      this.video2.current.classList.contains('hide') &&
      this.case2.current.getBoundingClientRect().bottom > window.innerHeight / 2
    ) {
      this.video1.current.classList.add('hide');
      this.video2.current.classList.remove('hide');
      this.video3.current.classList.add('hide');
      this.case1.current.classList.add('inactive');
      this.case2.current.classList.remove('inactive');
      this.case3.current.classList.add('inactive');
    }
    if (
      this.case3 &&
      this.case3.current.getBoundingClientRect().top < window.innerHeight / 2 &&
      this.video3.current.classList.contains('hide') &&
      this.case3.current.getBoundingClientRect().bottom > window.innerHeight / 2
    ) {
      this.video1.current.classList.add('hide');
      this.video2.current.classList.add('hide');
      this.video3.current.classList.remove('hide');
      this.case1.current.classList.add('inactive');
      this.case2.current.classList.add('inactive');
      this.case3.current.classList.remove('inactive');
    }
  }
  
  public render (props, state): any {
  
    return <div class="prodsDemo">
      <div class="descr" ref={this.case1}>
        <h3>
          <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/products-chatbot-assistant.png' } /> Querlo HR
        </h3>
        <p>Empower your HR department with AI.<br />Seamlessly integrate with your existing HR processes.</p>
        <ul>
          <li><div class="numbers"><span>-</span>20<span>%</span></div><span>costs</span></li>
          <li><div class="numbers"><span>&lt;</span>1<span>min.</span></div><span>average response time</span></li>
          <li><div class="numbers"><span>+</span>30<span>%</span></div><span>Employees satisfaction</span></li>
        </ul>
        <Link class="butt" href={BASE_URL + 'products/hr-assistant'}>Learn more</Link>
      </div>
      <div class="demo" ref={this.video1}>
        <div class="demoWrp">
          <div class="frame ipad">
            <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Chatbot Studio" />
            <div class="inframeWrp">
              <video autoplay loop muted class="inframe" src={ STATIC_BASE_URL + 'images/public/hr-ipad.mp4'} alt="HR video" />
            </div>
          </div>
        </div>
      </div>
    
      <div class="descr" ref={this.case2}>
        <h3><img alt="illustration" src={ STATIC_BASE_URL + 'images/public/products-leadgen.png' } /> Lead Gen</h3>
        <p>An AI Chatbot with a dedicated dashboard to streamline your lead generation.</p>
        <ul>
          <li><div class="numbers"><span>+</span>25<span>%</span></div><span>website conversion rate</span></li>
          <li><div class="numbers"><span>-</span>2<span>min.</span></div><span>average time to goal</span></li>
          <li><div class="numbers"><span>+</span>30<span>%</span></div><span>user satisfaction</span></li>
        </ul>
        <Link class="butt" href={BASE_URL + 'products/online-lead-gen'}>Learn more</Link>
      </div>
      <div class="demo hide" ref={this.video2}>
  
        <div class="demoWrp">
          <div class="frame ipad">
            <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Chatbot Studio"/>
            <div class="inframeWrp">
              <video autoPlay loop muted class="inframe" src={STATIC_BASE_URL + 'images/public/leadgen.mp4'}
                     alt="Chatbot Studio video"/>
            </div>
          </div>
        </div>
        
      </div>
    
      <div class="descr" ref={this.case3}>
        <h3><img alt="illustration" src="https://static.querlo.com/images/public/products-chatbot-studio.png" /> Chatbot Studio</h3>
        <p>Visually create your chatbots.</p>
        <ul>
          <li><div class="numbers">10</div><span>different type of nodes</span></li>
          <li><div class="numbers"><i class="fa fa-language"></i></div><span>leverage with leading NLU services</span></li>
          <li><div class="numbers"><i class="fa fa-users"></i></div><span>collaborate seamlessly with your team</span></li>
          <li><div class="numbers"><i class="fa fa-th-large"></i></div><span>split complex workflows in functional containers</span></li>
          <li><div class="numbers"><i class="fa fa-server"></i></div><span>demand advanced logics to your favourite server scripting language</span></li>
        </ul>
        <Link class="butt" href={BASE_URL + 'products/chatbot-studio'}>Learn more</Link>
      </div>
      <div class="demo hide" ref={this.video3}>
        
        <div class="demoWrp">
          <div class="frame ipad">
            <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Chatbot Studio" />
            <div class="inframeWrp">
              <video autoplay loop muted class="inframe" src={STATIC_BASE_URL + 'images/public/chatbotstudio.mp4'}
                     alt="Chatbot Studio video" />
            </div>
          </div>
        </div>
        
      </div>
  
      {/*<div class="descr" ref={this.case4}>
        <h3><img alt="illustration" src="https://static.querlo.com/images/public/products-chatbot-studio.png"/> AI E-commerce</h3>
        <p>Enhance your e-commerce experience embedding our assistant.</p>
        <ul>
          <ul>
            <li><div class="numbers"><span>+</span>20<span>%</span></div><span>increased sales</span></li>
            <li><div class="numbers"><span>+</span>10<span>%</span></div><span>high-value sales</span></li>
            <li><span>shop the website conversationally</span></li>
            <li><span>provide context aware tips</span></li>
          </ul>
        </ul>
        <Link class="butt" href={BASE_URL + 'products/chatbot-studio'}>Learn more</Link>
      </div>
      <div class="demo hide" ref={this.video4}>
    
        <div class="demoWrp">
          <div class="frame ipad">
            <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Chatbot Studio"/>
            <div class="inframeWrp">
              <video autoPlay loop muted class="inframe" src={STATIC_BASE_URL + 'images/public/chatbotstudio.mp4'}
                     alt="Chatbot Studio video"/>
            </div>
          </div>
        </div>
  
      </div>*/}
  
    </div>
  }
}


// WEBPACK FOOTER //
// ./ts/productsdemo.tsx